import { h, ComponentChildren } from 'preact'

// interface AspectImageProps {
//     className?: string;
//     children?: ComponentChildren;
//     onClick?: () => void;
//     loading?: 'lazy' | 'eager';
//     objectFit?: 'cover' | 'contain' | 'fill';
//     alt?: string;
//     title?: string;
//     src: string;
//     dataSrc?: string;
//     aspectRatio: {
//         x: number,
//         y: number
//     };
// }

export default function AspectImage({
    className,
    children,
    onClick,
    loading,
    alt,
    title,
    objectFit,
    src,
    dataSrc,
    aspectRatio = {
        x: 16,
        y: 9,
    },
}) {
    const ratio = aspectRatio.y / aspectRatio.x
    const paddingTop = `${ratio * 100}%`

    return (
        <figure
            className="aspect-img --relative"
            onClick={onClick}
            style={{
                paddingTop,
                width: '100%',
                position: 'relative',
            }}
        >
            <img
                className={className}
                src={src}
                data-src={dataSrc}
                loading={loading}
                alt={alt}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit,
                }}
            />
            {children && (children)}
        </figure>
    )
}
